import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import LayoutWrapper from "@/components/Layout/LayoutWrapper";
import AnalysisProvidersHeaderActions from "@/components/PageHeader/actions/pageHeaderActions/AnalysisProvidersHeaderActions/AnalysisProvidersHeaderActions";
import TabFilters from "@/components/TabFilters/TabFilters";
import useAnalysisProvidersInlineActions from "@/components/Table/actions/inlineActions/hooks/useAnalysisProvidersInlineActions";
import useTableInlineActions from "@/components/Table/hooks/useTableInlineActions";
import Table from "@/components/Table/Table";
import { USER_PERMISSIONS } from "@/roles/types/enums";
import { ROUTES, TABLE_NAMES } from "@/shared";
import useResponse from "@/shared/hooks/useResponse";
import { useIntegrationsDialogStore } from "@/stores/useIntegrationsDialogStore";
import { useAnalysisProvidersTableStore } from "@/stores/useTableStore";
import { getAccessStatus } from "@/stores/useUserDataStore";

import { INTEGRATIONS_PAGE_TABS } from "../config";
import IntegrationsDialogHub from "../IntegrationsDialogHub";

const AnalysisProviders = () => {
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { fetchData, setIsCheckable, resetInitialLoading, setInlineActions } =
    useAnalysisProvidersTableStore();

  const allowedToManageData = getAccessStatus(
    USER_PERMISSIONS.ManageIntegrations
  );

  const { inlineActions, isEditOpen, rowData } =
    useAnalysisProvidersInlineActions();

  const openEditDialog = useIntegrationsDialogStore(
    state => state.openEditAnalysisProvidersDialog
  );

  const {
    tableInlineActions,
    allowedToManageData: allowedToManageAnalysisProviders
  } = useTableInlineActions(inlineActions, USER_PERMISSIONS.ManageIntegrations);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      resetInitialLoading();
      handlePageLoad();
    }
  }, []);

  useEffect(() => {
    if (isEditOpen && rowData) {
      openEditDialog(rowData);
    }
  }, [isEditOpen, rowData]);

  const updateAnalysisProvidersActions = () => {
    setInlineActions(tableInlineActions);
    setIsCheckable(allowedToManageAnalysisProviders);
  };

  useEffect(() => {
    updateAnalysisProvidersActions();
  }, [tableInlineActions]);

  const handlePageLoad = async () => {
    updateAnalysisProvidersActions();
    await fetchData(getData, handleResponse);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection
        route={ROUTES.AnalysisProviders}
        tableName={TABLE_NAMES.Integrations}
      >
        {allowedToManageData && <AnalysisProvidersHeaderActions />}
      </LayoutWrapper>

      <Table
        route={ROUTES.AnalysisProviders}
        hasDetails
        tabFilters={<TabFilters tabs={INTEGRATIONS_PAGE_TABS} />}
        hasTabFilters
      />

      <IntegrationsDialogHub />
    </>
  );
};

export default AnalysisProviders;
